import { call, put, select, takeLatest } from 'redux-saga/effects'
import {
  setAnatomicLocationOptions,
  setSystemOptions,
  setFinalPatientAcuityOptions,
  setConditionAtDestOptions,
  setImpressionsOptions,
  setSymptomsOptions,
} from '../store/options.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { OptionsService } from '../services/options.service'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getDiagnosisOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const systemOptionsResponse: IOptionsResponse = yield call([optionsService, optionsService.getSystemOptions])
    yield put(setSystemOptions(systemOptionsResponse?.entity || []))

    const symptomsOptionsResponse: IOptionsResponse = yield call([optionsService, optionsService.getSymptomsOptions])
    yield put(setSymptomsOptions(symptomsOptionsResponse?.entity || []))

    const impresssionOptionsResponse: IOptionsResponse = yield call([
      optionsService,
      optionsService.getImpressionsOptions,
    ])
    yield put(setImpressionsOptions(impresssionOptionsResponse?.entity || []))

    const anatomicLocationOptionsResponse: IOptionsResponse = yield call([
      optionsService,
      optionsService.getAnatomicLocationOptions,
    ])
    yield put(setAnatomicLocationOptions(anatomicLocationOptionsResponse?.entity || []))

    const finalPatientAcuityOptionsResponse: IOptionsResponse = yield call([
      optionsService,
      optionsService.getFinalPatientAcuityOptions,
    ])
    yield put(setFinalPatientAcuityOptions(finalPatientAcuityOptionsResponse?.entity || []))

    const conditionAtDestOptionsResponse: IOptionsResponse = yield call([
      optionsService,
      optionsService.getConditionAtDestOptions,
    ])
    yield put(setConditionAtDestOptions(conditionAtDestOptionsResponse?.entity || []))
  } catch (e) {
    yield put(throwPcrException(`getDiagnosisOptions() error: ${e}`))
  }
}
export function* getDiagnosisOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getDiagnosisOptions)
}
